import { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import MeetExpertImg from "../../../../assets/icons/MeetExpertImg.svg";
import { useNavigate } from "react-router-dom";
import { Skeleton } from "primereact/skeleton";

const ExpertSessionCard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div
        className="charts position-relative"
        style={{
          width: "100%",
          height: "357px",
          borderRadius: "12px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
          padding: "20px",
        }}
      >
        <Skeleton width="150px" height="18px" className="mb-3" />
        <div className="d-flex justify-content-center mb-3">
          <Skeleton shape="circle" size="150px" />
        </div>
        <Skeleton width="100%" height="14px" className="mb-2" />
        <Skeleton width="80%" height="14px" className="mb-4" />
        <div className="d-flex justify-content-center">
          <Skeleton width="120px" height="38px" />
        </div>
      </div>
    );
  }

  return (
    <div
      className="charts d-flex justify-content-between position-relative"
      style={{
        width: "100%",
        height: "357px",
        borderRadius: "12px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
      }}
    >
      <Card className="text-center h-100 w-100 border-0">
        <Card.Body>
          <Card.Title className="text-start fs-6 mb-3">
            Talk with an Expert
          </Card.Title>

          <div className="d-flex justify-content-center mb-3">
            <img
              src={MeetExpertImg}
              alt="Talk with an Expert"
              className="rounded-circle"
              style={{
                width: "150px",
                height: "150px",
                objectFit: "cover",
              }}
            />
          </div>

            <Card.Text
          style={{
            fontSize: "clamp(12px, 0.9vw, 16px)",
            lineHeight: "1.4",
            marginTop: "10px",
            marginBottom: "10px",
            flexGrow: 1, 
          }}
        >
          Book online live interactive session with experts
        </Card.Text>

          <button
            className="w-md-50 rounded-2 mt-3 px-4 text-white btn btn-primary"
            onClick={() => navigate("/expert-sessions")}
          >
            View Schedule
          </button>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ExpertSessionCard;